import CodeMirror from 'codemirror'
import {
    isDate,
    isMetric,
    isNumber,
    isOperator,
    isProperty,
    isRelativeDate,
    isStringValue,
} from './syntax_common'

export const MERCHJAR_V1_MODE = 'merchjar-v1'

export const addSyntaxV1 = () => {
    if (CodeMirror.modes[MERCHJAR_V1_MODE]) return

    CodeMirror.defineMode(MERCHJAR_V1_MODE, () => ({
        startState: () => ({ tokenize: '', lastType: 'sof', isComment: false }),
        token: (stream, state) => {
            let ch = stream.next()
            if (!state.isComment && ch === '(') ch = stream.next()

            if (!state.isComment && ch === 'o' && stream.match('ver the')) {
                return 'keyword'
            } else if (
                !state.isComment &&
                ch === 'l' &&
                (stream.match('ifetime') || stream.match(/^ast \d+ days/))
            ) {
                return 'def'
            } else if (!state.isComment && isProperty(ch, stream)) {
                return 'property'
            } else if (!state.isComment && isMetric(window.isKdp, ch, stream)) {
                return 'metric'
            } else if (!state.isComment && isOperator(ch, stream)) {
                return 'operator'
            } else if (!state.isComment && (isDate(ch, stream) || isRelativeDate(ch, stream))) {
                return 'number'
            } else if (!state.isComment && isNumber(ch, stream)) {
                return 'number'
            } else if (!state.isComment && isStringValue(ch, stream)) {
                return 'string'
            } else if (!state.isComment && ch === 'a' && stream.match('nd')) {
                return 'keyword'
            } else if (!state.isComment && ch === 'o' && stream.match('r')) {
                return 'keyword'
            } else if (!state.isComment && ch === '/') {
                if (stream.match(/\/.*$/)) return 'comment2'
                if (stream.match('*')) {
                    state.isComment = true
                    return 'comment2'
                }
            } else if (state.isComment && ch === '*' && stream.match('/')) {
                state.isComment = false
                return 'comment2'
            } else if (state.isComment) {
                return 'comment2'
            }
            return null
        },
    }))
}
